import $ from 'jquery';
import checkMetamask from './checkMetamask/checkMetamask';
import {
  block,
  unblock,
} from './blocker';

export default async () => {
  if ($('.js-reload-partnership-items').length) {
    if (!await checkMetamask()) {
      return;
    }

    await (async () => {
      const widgetId = $('.js-reload-partnership-items').parent().data('designWidgetId');
      const accounts = await web3Client.eth.getAccounts();
      if (widgetId) {
        block();
        $.post(`/ajax/widget/render?cms_design_widget_id=${widgetId}&is_ajax=1`, `address=${accounts[0]}&chainId=${window.selectedChain === 'CHZ' ? window.chainIdChz : window.chainId}`, async (data) => {
          $(`.widget[data-design-widget-id="${widgetId}"]`).html(data);
          unblock();
        });
      }
    })();
  }
};
